/**
 * Página de Aviso Legal
 * 
 * Esta página muestra la información legal sobre las marcas registradas
 * y derechos de autor de Liga ProKids y Liga ProKids Summer Edition.
 */

const AvisoLegal = () => {
  // Estilos inline para asegurar que las secciones ocupen todo el ancho disponible
  const sectionStyle = {
    width: '100%',
    margin: 0,
    padding: '60px 0',
    boxSizing: 'border-box',
  };

  const containerStyle = {
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px',
    boxSizing: 'border-box',
  };

  return (
    <>
      {/* Hero Section */}
      <section
        className="hero"
        style={{
          ...sectionStyle,
          backgroundColor: '#F5F5F5',
          padding: '50px 0',
          overflow: 'hidden',
        }}
      >
        <div
          className="container"
          style={{
            ...containerStyle,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            textAlign: 'center',
          }}
        >
          <h1
            style={{
              fontSize: '3rem',
              fontWeight: '700',
              marginBottom: '15px',
              color: '#061156',
              lineHeight: '1.2',
            }}
          >
            🛡️ Aviso Legal
          </h1>
          <p
            style={{
              fontSize: '1.2rem',
              marginBottom: '0',
              color: '#061156',
              lineHeight: '1.6',
              maxWidth: '800px',
            }}
          >
            Información legal sobre las marcas registradas y derechos de autor de Liga ProKids.
          </p>
        </div>
      </section>

      {/* Contenido Legal */}
      <section
        style={{
          ...sectionStyle,
          backgroundColor: 'white',
        }}
      >
        <div className="container" style={containerStyle}>
          <div
            style={{
              maxWidth: '900px',
              margin: '0 auto',
              lineHeight: '1.8',
            }}
          >
            {/* Marcas Registradas */}
            <div style={{ marginBottom: '40px' }}>
              <p
                style={{
                  fontSize: '1.2rem',
                  color: '#333',
                  marginBottom: '30px',
                  textAlign: 'justify',
                }}
              >
                <strong>&ldquo;Liga ProKids®&rdquo;</strong> y <strong>&ldquo;Liga ProKids Summer Edition&rdquo;</strong> son marcas registradas.
                Todo el contenido de este programa, incluyendo su modelo organizativo, metodología formativa, 
                sistema de evolución individual (ProPoints), funcionamiento, comunicación, diseño, 
                materiales gráficos y estructura general, están protegidos por derechos de autor.
              </p>
            </div>

            {/* Prohibiciones */}
            <div style={{ marginBottom: '40px' }}>
              <p
                style={{
                  fontSize: '1.2rem',
                  color: '#333',
                  marginBottom: '30px',
                  textAlign: 'justify',
                }}
              >
                Queda prohibida su reproducción total o parcial, su uso o adaptación, 
                sin autorización expresa de los titulares del proyecto.
              </p>
            </div>

            {/* Consecuencias Legales */}
            <div style={{ marginBottom: '40px' }}>
              <p
                style={{
                  fontSize: '1.2rem',
                  color: '#333',
                  marginBottom: '30px',
                  textAlign: 'justify',
                }}
              >
                Cualquier intento de copia o réplica del sistema, formato o identidad, 
                será considerado una infracción legal y se procederá conforme a la 
                legislación vigente en materia de propiedad intelectual.
              </p>
            </div>

            {/* Nota Especial */}
            <div
              style={{
                backgroundColor: '#F8F9FA',
                border: '1px solid #E9ECEF',
                borderRadius: '10px',
                padding: '30px',
                marginTop: '40px',
              }}
            >
              <h3
                style={{
                  fontSize: '1.4rem',
                  fontWeight: '600',
                  marginBottom: '20px',
                  color: '#061156',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                📜 Nota Importante
              </h3>
              <p
                style={{
                  fontSize: '1.1rem',
                  color: '#333',
                  margin: 0,
                  textAlign: 'justify',
                }}
              >
                La Liga ProKids Summer Edition es un programa formativo privado de encuentros
                organizados por nivel y edad. No constituye una competición federada ni está
                sujeta a calendarios o clasificaciones oficiales. Su finalidad es el desarrollo
                individual a través de la práctica del fútbol en un entorno seguro, educativo y divertido.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Información de la Empresa */}
      <section
        style={{
          ...sectionStyle,
          backgroundColor: '#F8F9FA',
          borderTop: '1px solid #E9ECEF',
        }}
      >
        <div className="container" style={containerStyle}>
          <div
            style={{
              maxWidth: '900px',
              margin: '0 auto',
              textAlign: 'center',
            }}
          >
            <h2
              style={{
                fontSize: '2rem',
                fontWeight: '600',
                marginBottom: '30px',
                color: '#061156',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px',
              }}
            >
              🏢 Información de la Empresa
            </h2>

            <div
              style={{
                backgroundColor: 'white',
                border: '1px solid #E9ECEF',
                borderRadius: '10px',
                padding: '40px',
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
              }}
            >
              <h3
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  marginBottom: '25px',
                  color: '#061156',
                }}
              >
                AP8 SOCCER SPECIALISTS S.L.
              </h3>

              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                  gap: '20px',
                  textAlign: 'left',
                }}
              >
                <div>
                  <p
                    style={{
                      fontSize: '1.1rem',
                      color: '#333',
                      marginBottom: '10px',
                      lineHeight: '1.6',
                    }}
                  >
                    <strong>CIF:</strong> B72673528
                  </p>
                  <p
                    style={{
                      fontSize: '1.1rem',
                      color: '#333',
                      marginBottom: '10px',
                      lineHeight: '1.6',
                    }}
                  >
                    <strong>Registro Mercantil:</strong><br />
                    Tomo 4517, Folio 223, Sección 8, Hoja A 182341
                  </p>
                </div>

                <div>
                  <p
                    style={{
                      fontSize: '1.1rem',
                      color: '#333',
                      marginBottom: '10px',
                      lineHeight: '1.6',
                    }}
                  >
                    <strong>Inscripción/Anotación:</strong> 1
                  </p>
                  <p
                    style={{
                      fontSize: '1.1rem',
                      color: '#333',
                      marginBottom: '0',
                      lineHeight: '1.6',
                    }}
                  >
                    <strong>Fecha de inscripción:</strong> 21/11/2022
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sección de Contacto */}
      <section
        style={{
          ...sectionStyle,
          backgroundColor: '#F5F5F5',
          textAlign: 'center',
        }}
      >
        <div className="container" style={containerStyle}>
          <h2
            style={{
              fontSize: '2rem',
              fontWeight: '600',
              marginBottom: '20px',
              color: '#061156',
            }}
          >
            ¿Tienes alguna consulta legal?
          </h2>
          <p
            style={{
              fontSize: '1.1rem',
              color: '#666',
              lineHeight: '1.6',
              marginBottom: '30px',
            }}
          >
            Si tienes alguna pregunta sobre nuestros derechos de autor o marcas registradas, 
            no dudes en contactarnos.
          </p>
          <a
            href="/contact"
            style={{
              display: 'inline-block',
              padding: '15px 40px',
              backgroundColor: '#4352A9',
              color: 'white',
              borderRadius: '30px',
              fontWeight: '600',
              fontSize: '1.1rem',
              textDecoration: 'none',
              border: '2px solid #4352A9',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(67, 82, 169, 0.3)',
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#4352A9';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#4352A9';
              e.target.style.color = 'white';
            }}
          >
            Contactar
          </a>
        </div>
      </section>
    </>
  );
};

export default AvisoLegal;
